export default [{
  path: '/ForumMeetting',//会议安排 移动端
  name: 'meetingPage',
  component: () => import('@/view/ForumSpa/meeting.vue')
},{
  path: '/ForumHis',//历届论坛研讨会讲稿汇编
  name: 'hisFPage',
  component: () => import('@/view/ForumSpa/history.vue')
},{
  path: '/ForumPdf',//pdf 会议室情况
  name: 'pdfFPage',
  component: () => import('@/view/ForumSpa/pdf.vue')
},{
  path: '/ForumMeetDet',//会议安排详情
  name: 'meetDetFPage',
  component: () => import('@/view/ForumSpa/meetDet.vue')
},{
  path: '/ForumLecture',//历届论坛研讨会讲稿汇编
  name: 'lectureFPage',
  component: () => import('@/view/ForumSpa/lecture.vue')
},{
  path: '/ForumDownload',//历届论坛研讨会讲稿汇编下载
  name: 'downloadFPage',
  component: () => import('@/view/ForumSpa/download.vue')
},{
  path: '/ForumNewsDet',//新闻详情
  name: 'NewsDetFPage',
  component: () => import('@/view/ForumSpa/LatestPageDetail.vue')
}]




// WEBPACK FOOTER //
// ./src/router/ForumSpa.js